import { useMemo } from "react";
import { useRuntimeConfig } from "./useRuntimeConfig";

export const useBonusPagesConfig = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const enabledBonusesConfig = useMemo(
        () => COMMON_SITE_CONFIGS?._bonuses?.filter((config) => config.enable),
        [COMMON_SITE_CONFIGS._bonuses],
    );

    return enabledBonusesConfig;
};
